export const SUBMISSION_URL = "submission";

export const RECAPTCHA_SITE_KEY= '6LcP5XwpAAAAAGzyaVD2LZwEW8N0K3DyE4GepId2';

export const SUBMISSION_GET_CATEGORY_URL = `${SUBMISSION_URL}/form`;

export const SUBMISSION_POST_INSERT_URL = `${SUBMISSION_URL}/insert`;